import React from 'react';
import { trackWhatsAppClick } from '../../../utils/gtm';
import { IconWhatsApp } from './Icons';

/**
 * Desktop floating WhatsApp button for this page, drawn with the SVG icon.
 * Keeps the shared component's class name and `floating_button` tracking source,
 * so the existing mobile-hide rule and GTM setup still apply.
 */
const FloatingWhatsAppButton = () => (
  <a
    href="https://wa.me/971542119784"
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => trackWhatsAppClick('floating_button')}
    className="floating-wa-btn bk-floating-wa gtm-whatsapp-btn"
    data-gtm-id="floating-whatsapp"
  >
    <IconWhatsApp size={20} />
    <span>WhatsApp Us</span>
  </a>
);

export default FloatingWhatsAppButton;
